import ky from 'ky';
import Config from '../../config';
import Functions from '../../functions';

export interface MediaWikiPageData {
    title: string;
    text: string;
}

export interface MediaWikiContentData {
    id: number;
    title: string;
}

class MediaWikiUtils {
    private contents = new Map<string, number>();

    init(contents: MediaWikiContentData[]): void {
        this.contents = new Map(contents.map((content) => [content.title, content.id]));
    }

    getMainPageName(lang: string): string {
        return lang === 'en' ? 'Main_Page' : 'メインページ';
    }

    /** Resolves a page name as it appears in a URL to its content, or null if there is none. */
    async getPage(name: string): Promise<MediaWikiPageData | null> {
        const title = Functions.unescape(name).replace(/_/g, ' ');
        const id = this.contents.get(title);
        if (typeof id === 'undefined') {
            return null;
        }
        const url = new URL(`${Config.BASE_URL}/modules/mediawiki/contents/${id}.json`, window.location.href);
        try {
            return await ky.get(url).json<MediaWikiPageData>();
        } catch {
            return null;
        }
    }
}

export default new MediaWikiUtils();
